var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import classnames from 'classnames';
var Animation = function (_a) {
    var classes = _a.classes, reference = _a.reference, method = _a.method, _b = _a.configs, configs = _b === void 0 ? {} : _b, _c = _a.delay, delay = _c === void 0 ? null : _c, children = _a.children;
    useEffect(function () {
        if (method !== undefined && configs) {
            method(document.getElementById(reference), configs, delay);
        }
    }, [configs, delay, method, reference]);
    return _jsx("div", __assign({ className: classnames(classes) }, { children: children }), void 0);
};
export default Animation;
